import { withTheme } from 'styled-components';
import ThemeProps from 'admin-components/proptypes/groups/theme';
import PropTypes from 'prop-types';
import withLabel from '../withLabel';
import withValidation from '../withValidation';
import Select from './SelectField';

const ThemedSelect = withTheme(Select);
const LabeledSelect = withLabel(ThemedSelect);
const SelectField = withValidation(LabeledSelect);

SelectField.displayName = 'SelectField';

SelectField.propTypes = {
  ...Select.propTypes,
  ...LabeledSelect.propTypes,
  ...SelectField.propTypes,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number, ThemeProps.propTypes.breakpoints])
};

SelectField.defaultProps = {
  ...Select.defaultProps,
  ...LabeledSelect.defaultProps,
  ...SelectField.defaultProps
};

SelectField.propDescriptions = {
  ...Select.propDescriptions,
  ...LabeledSelect.propDescriptions,
  ...SelectField.propDescriptions
};

export default SelectField;
